import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const DataInspect = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M4,20H1c-0.5499878,0-1,0.4500122-1,1s0.4500122,1,1,1h3c0.5499878,0,1-0.4500122,1-1S4.5499878,20,4,20z" />
    <path d="M1,2h16c0.5499878,0,1-0.4500122,1-1s-0.4500122-1-1-1H1C0.4500122,0,0,0.4500122,0,1S0.4500122,2,1,2z" />
    <path d="M1,6h16c0.5499878,0,1-0.4500122,1-1s-0.4500122-1-1-1H1C0.4500122,4,0,4.4500122,0,5S0.4500122,6,1,6z" />
    <path d="M4,16H1c-0.5499878,0-1,0.4500122-1,1s0.4500122,1,1,1h3c0.5499878,0,1-0.4500122,1-1S4.5499878,16,4,16z" />
    <path d="M4,12H1c-0.5499878,0-1,0.4500122-1,1s0.4500122,1,1,1h3c0.5499878,0,1-0.4500122,1-1S4.5499878,12,4,12z" />
    <path d="M6,8H1C0.4500122,8,0,8.4500122,0,9s0.4500122,1,1,1h5c0.5499878,0,1-0.4500122,1-1S6.5499878,8,6,8z" />
    <path
      d="M18.2070312,13.2929688c-0.390625-0.390625-1.0234375-0.390625-1.4140625,0L13.5,16.5859375l-1.2929688-1.2929688
		c-0.390625-0.390625-1.0234375-0.390625-1.4140625,0s-0.390625,1.0234375,0,1.4140625l2,2
		C12.9882812,18.9023438,13.2441406,19,13.5,19s0.5117188-0.0976562,0.7070312-0.2929688l4-4
		C18.5976562,14.3164062,18.5976562,13.6835938,18.2070312,13.2929688z"
    />
    <path
      d="M23.7070312,22.2929688l-2.8434448-2.8434448C21.5792847,18.3007202,22,16.9500732,22,15.5
		c0-4.1350098-3.3649902-7.5-7.5-7.5S7,11.3649902,7,15.5s3.3649902,7.5,7.5,7.5
		c1.9622803,0,3.7456055-0.763916,5.0837402-2.0021973l2.7092285,2.7092285C22.4882812,23.9023438,22.7441406,24,23,24
		s0.5117188-0.0976562,0.7070312-0.2929688C24.0976562,23.3164062,24.0976562,22.6835938,23.7070312,22.2929688z M14.5,21
		C11.46698,21,9,18.53302,9,15.5s2.46698-5.5,5.5-5.5s5.5,2.46698,5.5,5.5S17.53302,21,14.5,21z"
    />
  </SvgIcon>
);

export default DataInspect;
